var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageflag)?_c('Echart',{ref:"charts",attrs:{"id":"leftCenter","options":_vm.options,"width":"100%","height":"245px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }